module.exports = __webpack_public_path__ + "static/media/causes_desktop_beyer_hero.134cea7b.jpg";